const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default API_URL;
